module.exports = __webpack_public_path__ + "static/media/Logo_Rasmi_KV.844254d5.png";